<template>
  <div>
    <v-layout v-if="service" wrap>
      <v-flex xs12>
        <v-card flat tile>
          <v-layout wrap>
            <v-flex xs12>
              <v-img
              v-if="service.coverpic"
                height="100vh"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.1)"
                :src="baseURL+service.coverpic"
                style="opacity: 1"
              >
                <v-layout justify-end wrap fill-height>
                  <v-flex xs10 align-self-center>
                    <v-layout justify-start fill-height>
                      <v-flex pr-7 xs12 lg9 align-self-center text-center>
                        <span
                          style="
                            font-family: poppinssemibold;
                            font-size: 28px;
                            color: #ffffff;
                            letter-spacing: 0px;
                          "
                        >
                         {{service.heading}}
                        </span></v-flex
                      >
                    </v-layout>
                    <br />

                    <v-layout justify-end wrap fill-height>
                      <v-flex align-self-center text-left xs12>
                        <span
                          style="
                            font-family: poppinssemibold;
                            font-size: 17px;
                            color: #ffffff;
                            letter-spacing: 1px;
                          "
                        >
                        {{service.text}}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-flex>
          </v-layout></v-card
        >
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      service:{},
    };
  },
    mounted: function () {
    this.getService();
  },
  methods: {
    getService()  {
      axios({
        method: "GET",
        url: "/service/view",
      })
        .then((response) => {
          if(response.data.status)
          this.service = response.data.data;
        })
        .catch(() => {});
    },
  },
};
</script>